import AddEmployee from "../AdminModule/AddEmployee";
import AllEmployee from "../AdminModule/AllEmployee";
import ViewEmployee from "../AdminModule/ViewEmployee";
import Attendance from "./Attendance";
import Dashboard from "../AdminModule/Dashboard";
import CheckBoardIcon from "../../assets/icons/checkboard";
import UsersIcon from "../../assets/icons/users";
import LeaveManagement from "./LeaveManagement";
import ListIcon from "../../assets/icons/list";
import RoleManagement from "./RoleManagement";
import DepartmentManagement from "./DepartmentManagement";
import CogIcon from "../../assets/icons/cog";
import DesignationManagement from "./DesignationManagement";
import GradeManagement from "./GradeManagement";
import HolidayManagement from "./HolidayManagement";
import EmployeeDetails from "../AdminModule/EmployeeDetails";
import { getUserRole, hasPermission } from "../../Utils/auth";
import DashboardIcon from "../../assets/icons/dashboard";
import LeaveRequests from "../AdminModule/LeaveRequests";
import Payroll from "../AdminModule/Payroll";
import FolderIcon from "../../assets/icons/folder";
import GenerateSalary from "../AdminModule/EditSalary";
import RequestDocument from "./RequestDocument";
import DocumentIcon from "../../assets/icons/document";
import GenerateDocument from "../AdminModule/GenerateDocument";
import TeamEmployee from "./TeamEmployee";
import TeamLeaders from "./TeamLeaders";
import Onboarding from "../AdminModule/Onboarding";
import AddCandidate from "../AdminModule/AddCandidate";
import UpdateCandidate from "../AdminModule/UpdateCandidate";
import AttendanceLog from "../AdminModule/AttendanceLog";
import EditSalary from "../AdminModule/EditSalary";

export const appRoutes = () => {
  const hasDashboardPermission = hasPermission("view_dashboard");
  const userRole = getUserRole();
  // Start with common routes
  const routes = {
    view_attendance: {
      key: "view_attendance",
      path: "/attendance-log",
      label: "Attendance Log",
      element: <AttendanceLog />,
      Icon: CheckBoardIcon,
      menuItem: true,
      menuOrder: 1,
    },
    view_team_employees: {
      key: "view_team_employees",
      path: "/team-employees",
      label: "Team Employees",
      element: <TeamEmployee />,
      Icon: UsersIcon,
      menuItem: true,
      menuOrder: 1,
    },
    view_team_leaders: {
      key: "view_team_leaders",
      path: "/team-leaders",
      label: "Team Leaders",
      element: <TeamLeaders />,
      Icon: UsersIcon,
      menuItem: true,
      menuOrder: 1,
    },
    manage_candidate: {
      key: "manage_candidate",
      path: "/onboarding",
      label: "Onboarding",
      element: <Onboarding />,
      Icon: UsersIcon,
      menuItem: true,
      menuOrder: 0,
    },
    add_candidate: {
      key: "add_candidate",
      path: "/add-candidate",
      label: "Add Candidate",
      element: <AddCandidate />,
      Icon: UsersIcon,
      menuItem: false,
    },
    edit_candidate: {
      key: "edit_candidate",
      path: "/edit-candidate/:id",
      label: "Edit Candidate",
      element: <UpdateCandidate />,
      Icon: UsersIcon,
      menuItem: false,
    },
    add_employees: {
      key: "add_employees",
      path: "/add-employee",
      label: "Add Employee",
      element: <AddEmployee />,
      Icon: UsersIcon,
      menuItem: false,
    },
    edit_employees: {
      key: "edit_employees",
      path: "/employee/:id",
      label: "Edit Employee",
      element: <EmployeeDetails />,
      Icon: UsersIcon,
      menuItem: false,
    },
    view_employees: {
      key: "view_employees",
      path: "/view-employee/:id",
      label: "Edit Employee",
      element: <ViewEmployee />,
      Icon: UsersIcon,
      menuItem: false,
    },
    manage_leaves: {
      key: "manage_leaves",
      path: "/leaves",
      label: "Leave Management",
      element: <LeaveManagement />,
      Icon: ListIcon,
      menuItem: true,
      menuOrder: 2,
    },
    view_leave_request: {
      key: "view_leave_request",
      path: "/leave-requests",
      label: "Leave Requests",
      element: <LeaveRequests />,
      Icon: ListIcon,
      menuItem: true,
      menuOrder: 3,
    },
    view_team_leaves: {
      key: "view_team_leaves",
      path: "/leave-requests",
      label: "Leave Requests",
      element: <LeaveRequests />,
      Icon: ListIcon,
      menuItem: true,
      menuOrder: 3,
    },
    view_roles: {
      key: "view_roles",
      path: "/role-management",
      label: "Manage Role",
      element: <RoleManagement />,
      Icon: CogIcon,
      menuItem: true,
      menuOrder: 4,
    },
    view_departments: {
      key: "view_departments",
      path: "/department-management",
      label: "Manage Department",
      element: <DepartmentManagement />,
      Icon: CogIcon,
      menuItem: true,
      menuOrder: 5,
    },
    view_designations: {
      key: "view_designations",
      path: "/designations-management",
      label: "Manage Designations",
      element: <DesignationManagement />,
      Icon: CogIcon,
      menuItem: true,
      menuOrder: 6,
    },
    view_grades: {
      key: "view_grades",
      path: "/grades-management",
      label: "Manage Grades",
      element: <GradeManagement />,
      Icon: CogIcon,
      menuItem: true,
      menuOrder: 7,
    },
    view_holidays: {
      key: "view_holidays",
      path: "/holiday-management",
      label: "Manage Holidays",
      element: <HolidayManagement />,
      Icon: CogIcon,
      menuItem: true,
      menuOrder: 8,
    },
    manage_salary: {
      key: "manage_salary",
      path: "/payroll",
      label: "Payroll",
      element: <Payroll />,
      Icon: FolderIcon,
      menuItem: true,
      menuOrder: 9,
    },
    generate_salary: {
      key: "generate_salary",
      path: "/generate-salary",
      label: "Generate Salary",
      element: <GenerateSalary />,
      Icon: FolderIcon,
      menuItem: false,
    },
    edit_salary: {
      key: "edit_salary",
      path: "/edit-salary/:id",
      label: "Edit Salary",
      element: <EditSalary />,
      Icon: FolderIcon,
      menuItem: false,
    },
    request_employee_documents_request: {
      key: "request_employee_documents_request",
      path: "/request-documents",
      label: "Request Documents",
      element: <RequestDocument />,
      Icon: DocumentIcon,
      menuItem: true,
      menuOrder: 10,
    },
    view_employee_documents_request: {
      key: "view_employee_documents_request",
      path: "/requested-documents",
      label: "Requested Documents",
      element: <GenerateDocument />,
      Icon: DocumentIcon,
      menuItem: true,
      menuOrder: 10,
    },
  };

  // Add Dashboard + Attendance depending on permission
  if (hasDashboardPermission) {
    routes.view_dashboard = {
      key: "view_dashboard",
      path: "/",
      label: "Dashboard",
      element: <Dashboard />,
      Icon: DashboardIcon,
      menuItem: true,
      menuOrder: 0,
    };
    routes.add_attendance = {
      key: "add_attendance",
      path: "/attendance",
      label: "Attendance",
      element: <Attendance />,
      Icon: CheckBoardIcon,
      menuItem: true,
      menuOrder: 1,
    };
  } else {
    routes.add_attendance = {
      key: "add_attendance",
      path: "/",
      label: "Attendance",
      element: <Attendance />,
      Icon: CheckBoardIcon,
      menuItem: true,
      menuOrder: 0,
    };
  }

  if (userRole.id === 2 || userRole.id === 3) {
    routes.manage_employees = {
      key: "manage_employees",
      path: "/employees",
      label: "All Employees",
      element: <AllEmployee />,
      Icon: UsersIcon,
      menuItem: true,
      menuOrder: 1,
    };
  }

  return routes;
};
